/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LayoutImport } from './routes/_layout'
import { Route as IndexImport } from './routes/index'
import { Route as authenticatedOrderStatusIndexImport } from './routes/(authenticated)/order-status/index'
import { Route as unathenticatedAuthLayoutImport } from './routes/(unathenticated)/auth/_layout'
import { Route as authenticatedDashboardLayoutImport } from './routes/(authenticated)/dashboard/_layout'
import { Route as unathenticatedAuthSplatIndexImport } from './routes/(unathenticated)/auth/$/index'
import { Route as authenticatedDashboardSplatIndexImport } from './routes/(authenticated)/dashboard/$/index'
import { Route as unathenticatedAuthLayoutRegistrationImport } from './routes/(unathenticated)/auth/_layout/registration'
import { Route as unathenticatedAuthLayoutNetworkRegistrationImport } from './routes/(unathenticated)/auth/_layout/network-registration'
import { Route as unathenticatedAuthLayoutLoginImport } from './routes/(unathenticated)/auth/_layout/login'
import { Route as unathenticatedAuthLayoutInvalidLinkImport } from './routes/(unathenticated)/auth/_layout/invalid-link'
import { Route as unathenticatedAuthLayoutForgottenPasswordImport } from './routes/(unathenticated)/auth/_layout/forgotten-password'
import { Route as unathenticatedAuthLayoutChangePasswordImport } from './routes/(unathenticated)/auth/_layout/change-password'
import { Route as globalOauth2CallbackHandlerImport } from './routes/(global)/oauth2/callback.$handler'
import { Route as authenticatedDashboardLayoutWalletImport } from './routes/(authenticated)/dashboard/_layout/wallet'
import { Route as authenticatedDashboardLayoutSubAffiliatesImport } from './routes/(authenticated)/dashboard/_layout/sub-affiliates'
import { Route as authenticatedDashboardLayoutOrderImport } from './routes/(authenticated)/dashboard/_layout/order'
import { Route as authenticatedDashboardLayoutHomeImport } from './routes/(authenticated)/dashboard/_layout/home'
import { Route as authenticatedDashboardLayoutDownloadsImport } from './routes/(authenticated)/dashboard/_layout/downloads'
import { Route as authenticatedDashboardLayoutCommissionsImport } from './routes/(authenticated)/dashboard/_layout/commissions'
import { Route as authenticatedDashboardLayoutUpgradeIndexImport } from './routes/(authenticated)/dashboard/_layout/upgrade/index'
import { Route as authenticatedDashboardLayoutUpgradeOrderIdImport } from './routes/(authenticated)/dashboard/_layout/upgrade/$order-id'
import { Route as authenticatedDashboardLayoutPayOrderIdImport } from './routes/(authenticated)/dashboard/_layout/pay.$order-id'
import { Route as authenticatedDashboardLayoutOrderOrderIdImport } from './routes/(authenticated)/dashboard/_layout/order.$order-id'
import { Route as authenticatedDashboardLayoutAdminLayoutImport } from './routes/(authenticated)/dashboard/_layout/admin/_layout'
import { Route as authenticatedDashboardLayoutAdminLayoutIndexImport } from './routes/(authenticated)/dashboard/_layout/admin/_layout/index'
import { Route as authenticatedDashboardLayoutUpgradePayOrderIdImport } from './routes/(authenticated)/dashboard/_layout/upgrade/pay.$order-id'
import { Route as authenticatedDashboardLayoutAdminLayoutDevelopmentImport } from './routes/(authenticated)/dashboard/_layout/admin/_layout/development'
import { Route as authenticatedDashboardLayoutAdminLayoutPromoterDetailUserIdImport } from './routes/(authenticated)/dashboard/_layout/admin/_layout/promoter-detail.$user-id'

// Create Virtual Routes

const unathenticatedAuthImport = createFileRoute('/(unathenticated)/auth')()
const authenticatedDashboardImport = createFileRoute(
  '/(authenticated)/dashboard',
)()
const authenticatedDashboardLayoutAdminImport = createFileRoute(
  '/(authenticated)/dashboard/_layout/admin',
)()

// Create/Update Routes

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const unathenticatedAuthRoute = unathenticatedAuthImport.update({
  id: '/(unathenticated)/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const authenticatedDashboardRoute = authenticatedDashboardImport.update({
  id: '/(authenticated)/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const authenticatedOrderStatusIndexRoute =
  authenticatedOrderStatusIndexImport.update({
    id: '/(authenticated)/order-status/',
    path: '/order-status/',
    getParentRoute: () => rootRoute,
  } as any)

const unathenticatedAuthLayoutRoute = unathenticatedAuthLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => unathenticatedAuthRoute,
} as any)

const authenticatedDashboardLayoutRoute =
  authenticatedDashboardLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => authenticatedDashboardRoute,
  } as any)

const authenticatedDashboardLayoutAdminRoute =
  authenticatedDashboardLayoutAdminImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => authenticatedDashboardLayoutRoute,
  } as any)

const unathenticatedAuthSplatIndexRoute =
  unathenticatedAuthSplatIndexImport.update({
    id: '/$/',
    path: '/$/',
    getParentRoute: () => unathenticatedAuthRoute,
  } as any)

const authenticatedDashboardSplatIndexRoute =
  authenticatedDashboardSplatIndexImport.update({
    id: '/$/',
    path: '/$/',
    getParentRoute: () => authenticatedDashboardRoute,
  } as any)

const unathenticatedAuthLayoutRegistrationRoute =
  unathenticatedAuthLayoutRegistrationImport.update({
    id: '/registration',
    path: '/registration',
    getParentRoute: () => unathenticatedAuthLayoutRoute,
  } as any)

const unathenticatedAuthLayoutNetworkRegistrationRoute =
  unathenticatedAuthLayoutNetworkRegistrationImport.update({
    id: '/network-registration',
    path: '/network-registration',
    getParentRoute: () => unathenticatedAuthLayoutRoute,
  } as any)

const unathenticatedAuthLayoutLoginRoute =
  unathenticatedAuthLayoutLoginImport.update({
    id: '/login',
    path: '/login',
    getParentRoute: () => unathenticatedAuthLayoutRoute,
  } as any)

const unathenticatedAuthLayoutInvalidLinkRoute =
  unathenticatedAuthLayoutInvalidLinkImport.update({
    id: '/invalid-link',
    path: '/invalid-link',
    getParentRoute: () => unathenticatedAuthLayoutRoute,
  } as any)

const unathenticatedAuthLayoutForgottenPasswordRoute =
  unathenticatedAuthLayoutForgottenPasswordImport.update({
    id: '/forgotten-password',
    path: '/forgotten-password',
    getParentRoute: () => unathenticatedAuthLayoutRoute,
  } as any)

const unathenticatedAuthLayoutChangePasswordRoute =
  unathenticatedAuthLayoutChangePasswordImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => unathenticatedAuthLayoutRoute,
  } as any)

const globalOauth2CallbackHandlerRoute =
  globalOauth2CallbackHandlerImport.update({
    id: '/(global)/oauth2/callback/$handler',
    path: '/oauth2/callback/$handler',
    getParentRoute: () => rootRoute,
  } as any)

const authenticatedDashboardLayoutWalletRoute =
  authenticatedDashboardLayoutWalletImport.update({
    id: '/wallet',
    path: '/wallet',
    getParentRoute: () => authenticatedDashboardLayoutRoute,
  } as any)

const authenticatedDashboardLayoutSubAffiliatesRoute =
  authenticatedDashboardLayoutSubAffiliatesImport.update({
    id: '/sub-affiliates',
    path: '/sub-affiliates',
    getParentRoute: () => authenticatedDashboardLayoutRoute,
  } as any)

const authenticatedDashboardLayoutOrderRoute =
  authenticatedDashboardLayoutOrderImport.update({
    id: '/order',
    path: '/order',
    getParentRoute: () => authenticatedDashboardLayoutRoute,
  } as any)

const authenticatedDashboardLayoutHomeRoute =
  authenticatedDashboardLayoutHomeImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => authenticatedDashboardLayoutRoute,
  } as any)

const authenticatedDashboardLayoutDownloadsRoute =
  authenticatedDashboardLayoutDownloadsImport.update({
    id: '/downloads',
    path: '/downloads',
    getParentRoute: () => authenticatedDashboardLayoutRoute,
  } as any)

const authenticatedDashboardLayoutCommissionsRoute =
  authenticatedDashboardLayoutCommissionsImport.update({
    id: '/commissions',
    path: '/commissions',
    getParentRoute: () => authenticatedDashboardLayoutRoute,
  } as any)

const authenticatedDashboardLayoutUpgradeIndexRoute =
  authenticatedDashboardLayoutUpgradeIndexImport.update({
    id: '/upgrade/',
    path: '/upgrade/',
    getParentRoute: () => authenticatedDashboardLayoutRoute,
  } as any)

const authenticatedDashboardLayoutUpgradeOrderIdRoute =
  authenticatedDashboardLayoutUpgradeOrderIdImport.update({
    id: '/upgrade/$order-id',
    path: '/upgrade/$order-id',
    getParentRoute: () => authenticatedDashboardLayoutRoute,
  } as any)

const authenticatedDashboardLayoutPayOrderIdRoute =
  authenticatedDashboardLayoutPayOrderIdImport.update({
    id: '/pay/$order-id',
    path: '/pay/$order-id',
    getParentRoute: () => authenticatedDashboardLayoutRoute,
  } as any)

const authenticatedDashboardLayoutOrderOrderIdRoute =
  authenticatedDashboardLayoutOrderOrderIdImport.update({
    id: '/$order-id',
    path: '/$order-id',
    getParentRoute: () => authenticatedDashboardLayoutOrderRoute,
  } as any)

const authenticatedDashboardLayoutAdminLayoutRoute =
  authenticatedDashboardLayoutAdminLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => authenticatedDashboardLayoutAdminRoute,
  } as any)

const authenticatedDashboardLayoutAdminLayoutIndexRoute =
  authenticatedDashboardLayoutAdminLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authenticatedDashboardLayoutAdminLayoutRoute,
  } as any)

const authenticatedDashboardLayoutUpgradePayOrderIdRoute =
  authenticatedDashboardLayoutUpgradePayOrderIdImport.update({
    id: '/upgrade/pay/$order-id',
    path: '/upgrade/pay/$order-id',
    getParentRoute: () => authenticatedDashboardLayoutRoute,
  } as any)

const authenticatedDashboardLayoutAdminLayoutDevelopmentRoute =
  authenticatedDashboardLayoutAdminLayoutDevelopmentImport.update({
    id: '/development',
    path: '/development',
    getParentRoute: () => authenticatedDashboardLayoutAdminLayoutRoute,
  } as any)

const authenticatedDashboardLayoutAdminLayoutPromoterDetailUserIdRoute =
  authenticatedDashboardLayoutAdminLayoutPromoterDetailUserIdImport.update({
    id: '/promoter-detail/$user-id',
    path: '/promoter-detail/$user-id',
    getParentRoute: () => authenticatedDashboardLayoutAdminLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)/dashboard': {
      id: '/(authenticated)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof authenticatedDashboardImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)/dashboard/_layout': {
      id: '/(authenticated)/dashboard/_layout'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof authenticatedDashboardLayoutImport
      parentRoute: typeof authenticatedDashboardRoute
    }
    '/(unathenticated)/auth': {
      id: '/(unathenticated)/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof unathenticatedAuthImport
      parentRoute: typeof rootRoute
    }
    '/(unathenticated)/auth/_layout': {
      id: '/(unathenticated)/auth/_layout'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof unathenticatedAuthLayoutImport
      parentRoute: typeof unathenticatedAuthRoute
    }
    '/(authenticated)/order-status/': {
      id: '/(authenticated)/order-status/'
      path: '/order-status'
      fullPath: '/order-status'
      preLoaderRoute: typeof authenticatedOrderStatusIndexImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)/dashboard/_layout/commissions': {
      id: '/(authenticated)/dashboard/_layout/commissions'
      path: '/commissions'
      fullPath: '/dashboard/commissions'
      preLoaderRoute: typeof authenticatedDashboardLayoutCommissionsImport
      parentRoute: typeof authenticatedDashboardLayoutImport
    }
    '/(authenticated)/dashboard/_layout/downloads': {
      id: '/(authenticated)/dashboard/_layout/downloads'
      path: '/downloads'
      fullPath: '/dashboard/downloads'
      preLoaderRoute: typeof authenticatedDashboardLayoutDownloadsImport
      parentRoute: typeof authenticatedDashboardLayoutImport
    }
    '/(authenticated)/dashboard/_layout/home': {
      id: '/(authenticated)/dashboard/_layout/home'
      path: '/home'
      fullPath: '/dashboard/home'
      preLoaderRoute: typeof authenticatedDashboardLayoutHomeImport
      parentRoute: typeof authenticatedDashboardLayoutImport
    }
    '/(authenticated)/dashboard/_layout/order': {
      id: '/(authenticated)/dashboard/_layout/order'
      path: '/order'
      fullPath: '/dashboard/order'
      preLoaderRoute: typeof authenticatedDashboardLayoutOrderImport
      parentRoute: typeof authenticatedDashboardLayoutImport
    }
    '/(authenticated)/dashboard/_layout/sub-affiliates': {
      id: '/(authenticated)/dashboard/_layout/sub-affiliates'
      path: '/sub-affiliates'
      fullPath: '/dashboard/sub-affiliates'
      preLoaderRoute: typeof authenticatedDashboardLayoutSubAffiliatesImport
      parentRoute: typeof authenticatedDashboardLayoutImport
    }
    '/(authenticated)/dashboard/_layout/wallet': {
      id: '/(authenticated)/dashboard/_layout/wallet'
      path: '/wallet'
      fullPath: '/dashboard/wallet'
      preLoaderRoute: typeof authenticatedDashboardLayoutWalletImport
      parentRoute: typeof authenticatedDashboardLayoutImport
    }
    '/(global)/oauth2/callback/$handler': {
      id: '/(global)/oauth2/callback/$handler'
      path: '/oauth2/callback/$handler'
      fullPath: '/oauth2/callback/$handler'
      preLoaderRoute: typeof globalOauth2CallbackHandlerImport
      parentRoute: typeof rootRoute
    }
    '/(unathenticated)/auth/_layout/change-password': {
      id: '/(unathenticated)/auth/_layout/change-password'
      path: '/change-password'
      fullPath: '/auth/change-password'
      preLoaderRoute: typeof unathenticatedAuthLayoutChangePasswordImport
      parentRoute: typeof unathenticatedAuthLayoutImport
    }
    '/(unathenticated)/auth/_layout/forgotten-password': {
      id: '/(unathenticated)/auth/_layout/forgotten-password'
      path: '/forgotten-password'
      fullPath: '/auth/forgotten-password'
      preLoaderRoute: typeof unathenticatedAuthLayoutForgottenPasswordImport
      parentRoute: typeof unathenticatedAuthLayoutImport
    }
    '/(unathenticated)/auth/_layout/invalid-link': {
      id: '/(unathenticated)/auth/_layout/invalid-link'
      path: '/invalid-link'
      fullPath: '/auth/invalid-link'
      preLoaderRoute: typeof unathenticatedAuthLayoutInvalidLinkImport
      parentRoute: typeof unathenticatedAuthLayoutImport
    }
    '/(unathenticated)/auth/_layout/login': {
      id: '/(unathenticated)/auth/_layout/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof unathenticatedAuthLayoutLoginImport
      parentRoute: typeof unathenticatedAuthLayoutImport
    }
    '/(unathenticated)/auth/_layout/network-registration': {
      id: '/(unathenticated)/auth/_layout/network-registration'
      path: '/network-registration'
      fullPath: '/auth/network-registration'
      preLoaderRoute: typeof unathenticatedAuthLayoutNetworkRegistrationImport
      parentRoute: typeof unathenticatedAuthLayoutImport
    }
    '/(unathenticated)/auth/_layout/registration': {
      id: '/(unathenticated)/auth/_layout/registration'
      path: '/registration'
      fullPath: '/auth/registration'
      preLoaderRoute: typeof unathenticatedAuthLayoutRegistrationImport
      parentRoute: typeof unathenticatedAuthLayoutImport
    }
    '/(authenticated)/dashboard/$/': {
      id: '/(authenticated)/dashboard/$/'
      path: '/$'
      fullPath: '/dashboard/$'
      preLoaderRoute: typeof authenticatedDashboardSplatIndexImport
      parentRoute: typeof authenticatedDashboardImport
    }
    '/(unathenticated)/auth/$/': {
      id: '/(unathenticated)/auth/$/'
      path: '/$'
      fullPath: '/auth/$'
      preLoaderRoute: typeof unathenticatedAuthSplatIndexImport
      parentRoute: typeof unathenticatedAuthImport
    }
    '/(authenticated)/dashboard/_layout/admin': {
      id: '/(authenticated)/dashboard/_layout/admin'
      path: '/admin'
      fullPath: '/dashboard/admin'
      preLoaderRoute: typeof authenticatedDashboardLayoutAdminImport
      parentRoute: typeof authenticatedDashboardLayoutImport
    }
    '/(authenticated)/dashboard/_layout/admin/_layout': {
      id: '/(authenticated)/dashboard/_layout/admin/_layout'
      path: '/admin'
      fullPath: '/dashboard/admin'
      preLoaderRoute: typeof authenticatedDashboardLayoutAdminLayoutImport
      parentRoute: typeof authenticatedDashboardLayoutAdminRoute
    }
    '/(authenticated)/dashboard/_layout/order/$order-id': {
      id: '/(authenticated)/dashboard/_layout/order/$order-id'
      path: '/$order-id'
      fullPath: '/dashboard/order/$order-id'
      preLoaderRoute: typeof authenticatedDashboardLayoutOrderOrderIdImport
      parentRoute: typeof authenticatedDashboardLayoutOrderImport
    }
    '/(authenticated)/dashboard/_layout/pay/$order-id': {
      id: '/(authenticated)/dashboard/_layout/pay/$order-id'
      path: '/pay/$order-id'
      fullPath: '/dashboard/pay/$order-id'
      preLoaderRoute: typeof authenticatedDashboardLayoutPayOrderIdImport
      parentRoute: typeof authenticatedDashboardLayoutImport
    }
    '/(authenticated)/dashboard/_layout/upgrade/$order-id': {
      id: '/(authenticated)/dashboard/_layout/upgrade/$order-id'
      path: '/upgrade/$order-id'
      fullPath: '/dashboard/upgrade/$order-id'
      preLoaderRoute: typeof authenticatedDashboardLayoutUpgradeOrderIdImport
      parentRoute: typeof authenticatedDashboardLayoutImport
    }
    '/(authenticated)/dashboard/_layout/upgrade/': {
      id: '/(authenticated)/dashboard/_layout/upgrade/'
      path: '/upgrade'
      fullPath: '/dashboard/upgrade'
      preLoaderRoute: typeof authenticatedDashboardLayoutUpgradeIndexImport
      parentRoute: typeof authenticatedDashboardLayoutImport
    }
    '/(authenticated)/dashboard/_layout/admin/_layout/development': {
      id: '/(authenticated)/dashboard/_layout/admin/_layout/development'
      path: '/development'
      fullPath: '/dashboard/admin/development'
      preLoaderRoute: typeof authenticatedDashboardLayoutAdminLayoutDevelopmentImport
      parentRoute: typeof authenticatedDashboardLayoutAdminLayoutImport
    }
    '/(authenticated)/dashboard/_layout/upgrade/pay/$order-id': {
      id: '/(authenticated)/dashboard/_layout/upgrade/pay/$order-id'
      path: '/upgrade/pay/$order-id'
      fullPath: '/dashboard/upgrade/pay/$order-id'
      preLoaderRoute: typeof authenticatedDashboardLayoutUpgradePayOrderIdImport
      parentRoute: typeof authenticatedDashboardLayoutImport
    }
    '/(authenticated)/dashboard/_layout/admin/_layout/': {
      id: '/(authenticated)/dashboard/_layout/admin/_layout/'
      path: '/'
      fullPath: '/dashboard/admin/'
      preLoaderRoute: typeof authenticatedDashboardLayoutAdminLayoutIndexImport
      parentRoute: typeof authenticatedDashboardLayoutAdminLayoutImport
    }
    '/(authenticated)/dashboard/_layout/admin/_layout/promoter-detail/$user-id': {
      id: '/(authenticated)/dashboard/_layout/admin/_layout/promoter-detail/$user-id'
      path: '/promoter-detail/$user-id'
      fullPath: '/dashboard/admin/promoter-detail/$user-id'
      preLoaderRoute: typeof authenticatedDashboardLayoutAdminLayoutPromoterDetailUserIdImport
      parentRoute: typeof authenticatedDashboardLayoutAdminLayoutImport
    }
  }
}

// Create and export the route tree

interface authenticatedDashboardLayoutOrderRouteChildren {
  authenticatedDashboardLayoutOrderOrderIdRoute: typeof authenticatedDashboardLayoutOrderOrderIdRoute
}

const authenticatedDashboardLayoutOrderRouteChildren: authenticatedDashboardLayoutOrderRouteChildren =
  {
    authenticatedDashboardLayoutOrderOrderIdRoute:
      authenticatedDashboardLayoutOrderOrderIdRoute,
  }

const authenticatedDashboardLayoutOrderRouteWithChildren =
  authenticatedDashboardLayoutOrderRoute._addFileChildren(
    authenticatedDashboardLayoutOrderRouteChildren,
  )

interface authenticatedDashboardLayoutAdminLayoutRouteChildren {
  authenticatedDashboardLayoutAdminLayoutDevelopmentRoute: typeof authenticatedDashboardLayoutAdminLayoutDevelopmentRoute
  authenticatedDashboardLayoutAdminLayoutIndexRoute: typeof authenticatedDashboardLayoutAdminLayoutIndexRoute
  authenticatedDashboardLayoutAdminLayoutPromoterDetailUserIdRoute: typeof authenticatedDashboardLayoutAdminLayoutPromoterDetailUserIdRoute
}

const authenticatedDashboardLayoutAdminLayoutRouteChildren: authenticatedDashboardLayoutAdminLayoutRouteChildren =
  {
    authenticatedDashboardLayoutAdminLayoutDevelopmentRoute:
      authenticatedDashboardLayoutAdminLayoutDevelopmentRoute,
    authenticatedDashboardLayoutAdminLayoutIndexRoute:
      authenticatedDashboardLayoutAdminLayoutIndexRoute,
    authenticatedDashboardLayoutAdminLayoutPromoterDetailUserIdRoute:
      authenticatedDashboardLayoutAdminLayoutPromoterDetailUserIdRoute,
  }

const authenticatedDashboardLayoutAdminLayoutRouteWithChildren =
  authenticatedDashboardLayoutAdminLayoutRoute._addFileChildren(
    authenticatedDashboardLayoutAdminLayoutRouteChildren,
  )

interface authenticatedDashboardLayoutAdminRouteChildren {
  authenticatedDashboardLayoutAdminLayoutRoute: typeof authenticatedDashboardLayoutAdminLayoutRouteWithChildren
}

const authenticatedDashboardLayoutAdminRouteChildren: authenticatedDashboardLayoutAdminRouteChildren =
  {
    authenticatedDashboardLayoutAdminLayoutRoute:
      authenticatedDashboardLayoutAdminLayoutRouteWithChildren,
  }

const authenticatedDashboardLayoutAdminRouteWithChildren =
  authenticatedDashboardLayoutAdminRoute._addFileChildren(
    authenticatedDashboardLayoutAdminRouteChildren,
  )

interface authenticatedDashboardLayoutRouteChildren {
  authenticatedDashboardLayoutCommissionsRoute: typeof authenticatedDashboardLayoutCommissionsRoute
  authenticatedDashboardLayoutDownloadsRoute: typeof authenticatedDashboardLayoutDownloadsRoute
  authenticatedDashboardLayoutHomeRoute: typeof authenticatedDashboardLayoutHomeRoute
  authenticatedDashboardLayoutOrderRoute: typeof authenticatedDashboardLayoutOrderRouteWithChildren
  authenticatedDashboardLayoutSubAffiliatesRoute: typeof authenticatedDashboardLayoutSubAffiliatesRoute
  authenticatedDashboardLayoutWalletRoute: typeof authenticatedDashboardLayoutWalletRoute
  authenticatedDashboardLayoutAdminRoute: typeof authenticatedDashboardLayoutAdminRouteWithChildren
  authenticatedDashboardLayoutPayOrderIdRoute: typeof authenticatedDashboardLayoutPayOrderIdRoute
  authenticatedDashboardLayoutUpgradeOrderIdRoute: typeof authenticatedDashboardLayoutUpgradeOrderIdRoute
  authenticatedDashboardLayoutUpgradeIndexRoute: typeof authenticatedDashboardLayoutUpgradeIndexRoute
  authenticatedDashboardLayoutUpgradePayOrderIdRoute: typeof authenticatedDashboardLayoutUpgradePayOrderIdRoute
}

const authenticatedDashboardLayoutRouteChildren: authenticatedDashboardLayoutRouteChildren =
  {
    authenticatedDashboardLayoutCommissionsRoute:
      authenticatedDashboardLayoutCommissionsRoute,
    authenticatedDashboardLayoutDownloadsRoute:
      authenticatedDashboardLayoutDownloadsRoute,
    authenticatedDashboardLayoutHomeRoute:
      authenticatedDashboardLayoutHomeRoute,
    authenticatedDashboardLayoutOrderRoute:
      authenticatedDashboardLayoutOrderRouteWithChildren,
    authenticatedDashboardLayoutSubAffiliatesRoute:
      authenticatedDashboardLayoutSubAffiliatesRoute,
    authenticatedDashboardLayoutWalletRoute:
      authenticatedDashboardLayoutWalletRoute,
    authenticatedDashboardLayoutAdminRoute:
      authenticatedDashboardLayoutAdminRouteWithChildren,
    authenticatedDashboardLayoutPayOrderIdRoute:
      authenticatedDashboardLayoutPayOrderIdRoute,
    authenticatedDashboardLayoutUpgradeOrderIdRoute:
      authenticatedDashboardLayoutUpgradeOrderIdRoute,
    authenticatedDashboardLayoutUpgradeIndexRoute:
      authenticatedDashboardLayoutUpgradeIndexRoute,
    authenticatedDashboardLayoutUpgradePayOrderIdRoute:
      authenticatedDashboardLayoutUpgradePayOrderIdRoute,
  }

const authenticatedDashboardLayoutRouteWithChildren =
  authenticatedDashboardLayoutRoute._addFileChildren(
    authenticatedDashboardLayoutRouteChildren,
  )

interface authenticatedDashboardRouteChildren {
  authenticatedDashboardLayoutRoute: typeof authenticatedDashboardLayoutRouteWithChildren
  authenticatedDashboardSplatIndexRoute: typeof authenticatedDashboardSplatIndexRoute
}

const authenticatedDashboardRouteChildren: authenticatedDashboardRouteChildren =
  {
    authenticatedDashboardLayoutRoute:
      authenticatedDashboardLayoutRouteWithChildren,
    authenticatedDashboardSplatIndexRoute:
      authenticatedDashboardSplatIndexRoute,
  }

const authenticatedDashboardRouteWithChildren =
  authenticatedDashboardRoute._addFileChildren(
    authenticatedDashboardRouteChildren,
  )

interface unathenticatedAuthLayoutRouteChildren {
  unathenticatedAuthLayoutChangePasswordRoute: typeof unathenticatedAuthLayoutChangePasswordRoute
  unathenticatedAuthLayoutForgottenPasswordRoute: typeof unathenticatedAuthLayoutForgottenPasswordRoute
  unathenticatedAuthLayoutInvalidLinkRoute: typeof unathenticatedAuthLayoutInvalidLinkRoute
  unathenticatedAuthLayoutLoginRoute: typeof unathenticatedAuthLayoutLoginRoute
  unathenticatedAuthLayoutNetworkRegistrationRoute: typeof unathenticatedAuthLayoutNetworkRegistrationRoute
  unathenticatedAuthLayoutRegistrationRoute: typeof unathenticatedAuthLayoutRegistrationRoute
}

const unathenticatedAuthLayoutRouteChildren: unathenticatedAuthLayoutRouteChildren =
  {
    unathenticatedAuthLayoutChangePasswordRoute:
      unathenticatedAuthLayoutChangePasswordRoute,
    unathenticatedAuthLayoutForgottenPasswordRoute:
      unathenticatedAuthLayoutForgottenPasswordRoute,
    unathenticatedAuthLayoutInvalidLinkRoute:
      unathenticatedAuthLayoutInvalidLinkRoute,
    unathenticatedAuthLayoutLoginRoute: unathenticatedAuthLayoutLoginRoute,
    unathenticatedAuthLayoutNetworkRegistrationRoute:
      unathenticatedAuthLayoutNetworkRegistrationRoute,
    unathenticatedAuthLayoutRegistrationRoute:
      unathenticatedAuthLayoutRegistrationRoute,
  }

const unathenticatedAuthLayoutRouteWithChildren =
  unathenticatedAuthLayoutRoute._addFileChildren(
    unathenticatedAuthLayoutRouteChildren,
  )

interface unathenticatedAuthRouteChildren {
  unathenticatedAuthLayoutRoute: typeof unathenticatedAuthLayoutRouteWithChildren
  unathenticatedAuthSplatIndexRoute: typeof unathenticatedAuthSplatIndexRoute
}

const unathenticatedAuthRouteChildren: unathenticatedAuthRouteChildren = {
  unathenticatedAuthLayoutRoute: unathenticatedAuthLayoutRouteWithChildren,
  unathenticatedAuthSplatIndexRoute: unathenticatedAuthSplatIndexRoute,
}

const unathenticatedAuthRouteWithChildren =
  unathenticatedAuthRoute._addFileChildren(unathenticatedAuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof LayoutRoute
  '/dashboard': typeof authenticatedDashboardLayoutRouteWithChildren
  '/auth': typeof unathenticatedAuthLayoutRouteWithChildren
  '/order-status': typeof authenticatedOrderStatusIndexRoute
  '/dashboard/commissions': typeof authenticatedDashboardLayoutCommissionsRoute
  '/dashboard/downloads': typeof authenticatedDashboardLayoutDownloadsRoute
  '/dashboard/home': typeof authenticatedDashboardLayoutHomeRoute
  '/dashboard/order': typeof authenticatedDashboardLayoutOrderRouteWithChildren
  '/dashboard/sub-affiliates': typeof authenticatedDashboardLayoutSubAffiliatesRoute
  '/dashboard/wallet': typeof authenticatedDashboardLayoutWalletRoute
  '/oauth2/callback/$handler': typeof globalOauth2CallbackHandlerRoute
  '/auth/change-password': typeof unathenticatedAuthLayoutChangePasswordRoute
  '/auth/forgotten-password': typeof unathenticatedAuthLayoutForgottenPasswordRoute
  '/auth/invalid-link': typeof unathenticatedAuthLayoutInvalidLinkRoute
  '/auth/login': typeof unathenticatedAuthLayoutLoginRoute
  '/auth/network-registration': typeof unathenticatedAuthLayoutNetworkRegistrationRoute
  '/auth/registration': typeof unathenticatedAuthLayoutRegistrationRoute
  '/dashboard/$': typeof authenticatedDashboardSplatIndexRoute
  '/auth/$': typeof unathenticatedAuthSplatIndexRoute
  '/dashboard/admin': typeof authenticatedDashboardLayoutAdminLayoutRouteWithChildren
  '/dashboard/order/$order-id': typeof authenticatedDashboardLayoutOrderOrderIdRoute
  '/dashboard/pay/$order-id': typeof authenticatedDashboardLayoutPayOrderIdRoute
  '/dashboard/upgrade/$order-id': typeof authenticatedDashboardLayoutUpgradeOrderIdRoute
  '/dashboard/upgrade': typeof authenticatedDashboardLayoutUpgradeIndexRoute
  '/dashboard/admin/development': typeof authenticatedDashboardLayoutAdminLayoutDevelopmentRoute
  '/dashboard/upgrade/pay/$order-id': typeof authenticatedDashboardLayoutUpgradePayOrderIdRoute
  '/dashboard/admin/': typeof authenticatedDashboardLayoutAdminLayoutIndexRoute
  '/dashboard/admin/promoter-detail/$user-id': typeof authenticatedDashboardLayoutAdminLayoutPromoterDetailUserIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof LayoutRoute
  '/dashboard': typeof authenticatedDashboardLayoutRouteWithChildren
  '/auth': typeof unathenticatedAuthLayoutRouteWithChildren
  '/order-status': typeof authenticatedOrderStatusIndexRoute
  '/dashboard/commissions': typeof authenticatedDashboardLayoutCommissionsRoute
  '/dashboard/downloads': typeof authenticatedDashboardLayoutDownloadsRoute
  '/dashboard/home': typeof authenticatedDashboardLayoutHomeRoute
  '/dashboard/order': typeof authenticatedDashboardLayoutOrderRouteWithChildren
  '/dashboard/sub-affiliates': typeof authenticatedDashboardLayoutSubAffiliatesRoute
  '/dashboard/wallet': typeof authenticatedDashboardLayoutWalletRoute
  '/oauth2/callback/$handler': typeof globalOauth2CallbackHandlerRoute
  '/auth/change-password': typeof unathenticatedAuthLayoutChangePasswordRoute
  '/auth/forgotten-password': typeof unathenticatedAuthLayoutForgottenPasswordRoute
  '/auth/invalid-link': typeof unathenticatedAuthLayoutInvalidLinkRoute
  '/auth/login': typeof unathenticatedAuthLayoutLoginRoute
  '/auth/network-registration': typeof unathenticatedAuthLayoutNetworkRegistrationRoute
  '/auth/registration': typeof unathenticatedAuthLayoutRegistrationRoute
  '/dashboard/$': typeof authenticatedDashboardSplatIndexRoute
  '/auth/$': typeof unathenticatedAuthSplatIndexRoute
  '/dashboard/admin': typeof authenticatedDashboardLayoutAdminLayoutIndexRoute
  '/dashboard/order/$order-id': typeof authenticatedDashboardLayoutOrderOrderIdRoute
  '/dashboard/pay/$order-id': typeof authenticatedDashboardLayoutPayOrderIdRoute
  '/dashboard/upgrade/$order-id': typeof authenticatedDashboardLayoutUpgradeOrderIdRoute
  '/dashboard/upgrade': typeof authenticatedDashboardLayoutUpgradeIndexRoute
  '/dashboard/admin/development': typeof authenticatedDashboardLayoutAdminLayoutDevelopmentRoute
  '/dashboard/upgrade/pay/$order-id': typeof authenticatedDashboardLayoutUpgradePayOrderIdRoute
  '/dashboard/admin/promoter-detail/$user-id': typeof authenticatedDashboardLayoutAdminLayoutPromoterDetailUserIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_layout': typeof LayoutRoute
  '/(authenticated)/dashboard': typeof authenticatedDashboardRouteWithChildren
  '/(authenticated)/dashboard/_layout': typeof authenticatedDashboardLayoutRouteWithChildren
  '/(unathenticated)/auth': typeof unathenticatedAuthRouteWithChildren
  '/(unathenticated)/auth/_layout': typeof unathenticatedAuthLayoutRouteWithChildren
  '/(authenticated)/order-status/': typeof authenticatedOrderStatusIndexRoute
  '/(authenticated)/dashboard/_layout/commissions': typeof authenticatedDashboardLayoutCommissionsRoute
  '/(authenticated)/dashboard/_layout/downloads': typeof authenticatedDashboardLayoutDownloadsRoute
  '/(authenticated)/dashboard/_layout/home': typeof authenticatedDashboardLayoutHomeRoute
  '/(authenticated)/dashboard/_layout/order': typeof authenticatedDashboardLayoutOrderRouteWithChildren
  '/(authenticated)/dashboard/_layout/sub-affiliates': typeof authenticatedDashboardLayoutSubAffiliatesRoute
  '/(authenticated)/dashboard/_layout/wallet': typeof authenticatedDashboardLayoutWalletRoute
  '/(global)/oauth2/callback/$handler': typeof globalOauth2CallbackHandlerRoute
  '/(unathenticated)/auth/_layout/change-password': typeof unathenticatedAuthLayoutChangePasswordRoute
  '/(unathenticated)/auth/_layout/forgotten-password': typeof unathenticatedAuthLayoutForgottenPasswordRoute
  '/(unathenticated)/auth/_layout/invalid-link': typeof unathenticatedAuthLayoutInvalidLinkRoute
  '/(unathenticated)/auth/_layout/login': typeof unathenticatedAuthLayoutLoginRoute
  '/(unathenticated)/auth/_layout/network-registration': typeof unathenticatedAuthLayoutNetworkRegistrationRoute
  '/(unathenticated)/auth/_layout/registration': typeof unathenticatedAuthLayoutRegistrationRoute
  '/(authenticated)/dashboard/$/': typeof authenticatedDashboardSplatIndexRoute
  '/(unathenticated)/auth/$/': typeof unathenticatedAuthSplatIndexRoute
  '/(authenticated)/dashboard/_layout/admin': typeof authenticatedDashboardLayoutAdminRouteWithChildren
  '/(authenticated)/dashboard/_layout/admin/_layout': typeof authenticatedDashboardLayoutAdminLayoutRouteWithChildren
  '/(authenticated)/dashboard/_layout/order/$order-id': typeof authenticatedDashboardLayoutOrderOrderIdRoute
  '/(authenticated)/dashboard/_layout/pay/$order-id': typeof authenticatedDashboardLayoutPayOrderIdRoute
  '/(authenticated)/dashboard/_layout/upgrade/$order-id': typeof authenticatedDashboardLayoutUpgradeOrderIdRoute
  '/(authenticated)/dashboard/_layout/upgrade/': typeof authenticatedDashboardLayoutUpgradeIndexRoute
  '/(authenticated)/dashboard/_layout/admin/_layout/development': typeof authenticatedDashboardLayoutAdminLayoutDevelopmentRoute
  '/(authenticated)/dashboard/_layout/upgrade/pay/$order-id': typeof authenticatedDashboardLayoutUpgradePayOrderIdRoute
  '/(authenticated)/dashboard/_layout/admin/_layout/': typeof authenticatedDashboardLayoutAdminLayoutIndexRoute
  '/(authenticated)/dashboard/_layout/admin/_layout/promoter-detail/$user-id': typeof authenticatedDashboardLayoutAdminLayoutPromoterDetailUserIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/dashboard'
    | '/auth'
    | '/order-status'
    | '/dashboard/commissions'
    | '/dashboard/downloads'
    | '/dashboard/home'
    | '/dashboard/order'
    | '/dashboard/sub-affiliates'
    | '/dashboard/wallet'
    | '/oauth2/callback/$handler'
    | '/auth/change-password'
    | '/auth/forgotten-password'
    | '/auth/invalid-link'
    | '/auth/login'
    | '/auth/network-registration'
    | '/auth/registration'
    | '/dashboard/$'
    | '/auth/$'
    | '/dashboard/admin'
    | '/dashboard/order/$order-id'
    | '/dashboard/pay/$order-id'
    | '/dashboard/upgrade/$order-id'
    | '/dashboard/upgrade'
    | '/dashboard/admin/development'
    | '/dashboard/upgrade/pay/$order-id'
    | '/dashboard/admin/'
    | '/dashboard/admin/promoter-detail/$user-id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/dashboard'
    | '/auth'
    | '/order-status'
    | '/dashboard/commissions'
    | '/dashboard/downloads'
    | '/dashboard/home'
    | '/dashboard/order'
    | '/dashboard/sub-affiliates'
    | '/dashboard/wallet'
    | '/oauth2/callback/$handler'
    | '/auth/change-password'
    | '/auth/forgotten-password'
    | '/auth/invalid-link'
    | '/auth/login'
    | '/auth/network-registration'
    | '/auth/registration'
    | '/dashboard/$'
    | '/auth/$'
    | '/dashboard/admin'
    | '/dashboard/order/$order-id'
    | '/dashboard/pay/$order-id'
    | '/dashboard/upgrade/$order-id'
    | '/dashboard/upgrade'
    | '/dashboard/admin/development'
    | '/dashboard/upgrade/pay/$order-id'
    | '/dashboard/admin/promoter-detail/$user-id'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/(authenticated)/dashboard'
    | '/(authenticated)/dashboard/_layout'
    | '/(unathenticated)/auth'
    | '/(unathenticated)/auth/_layout'
    | '/(authenticated)/order-status/'
    | '/(authenticated)/dashboard/_layout/commissions'
    | '/(authenticated)/dashboard/_layout/downloads'
    | '/(authenticated)/dashboard/_layout/home'
    | '/(authenticated)/dashboard/_layout/order'
    | '/(authenticated)/dashboard/_layout/sub-affiliates'
    | '/(authenticated)/dashboard/_layout/wallet'
    | '/(global)/oauth2/callback/$handler'
    | '/(unathenticated)/auth/_layout/change-password'
    | '/(unathenticated)/auth/_layout/forgotten-password'
    | '/(unathenticated)/auth/_layout/invalid-link'
    | '/(unathenticated)/auth/_layout/login'
    | '/(unathenticated)/auth/_layout/network-registration'
    | '/(unathenticated)/auth/_layout/registration'
    | '/(authenticated)/dashboard/$/'
    | '/(unathenticated)/auth/$/'
    | '/(authenticated)/dashboard/_layout/admin'
    | '/(authenticated)/dashboard/_layout/admin/_layout'
    | '/(authenticated)/dashboard/_layout/order/$order-id'
    | '/(authenticated)/dashboard/_layout/pay/$order-id'
    | '/(authenticated)/dashboard/_layout/upgrade/$order-id'
    | '/(authenticated)/dashboard/_layout/upgrade/'
    | '/(authenticated)/dashboard/_layout/admin/_layout/development'
    | '/(authenticated)/dashboard/_layout/upgrade/pay/$order-id'
    | '/(authenticated)/dashboard/_layout/admin/_layout/'
    | '/(authenticated)/dashboard/_layout/admin/_layout/promoter-detail/$user-id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LayoutRoute: typeof LayoutRoute
  authenticatedDashboardRoute: typeof authenticatedDashboardRouteWithChildren
  unathenticatedAuthRoute: typeof unathenticatedAuthRouteWithChildren
  authenticatedOrderStatusIndexRoute: typeof authenticatedOrderStatusIndexRoute
  globalOauth2CallbackHandlerRoute: typeof globalOauth2CallbackHandlerRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LayoutRoute: LayoutRoute,
  authenticatedDashboardRoute: authenticatedDashboardRouteWithChildren,
  unathenticatedAuthRoute: unathenticatedAuthRouteWithChildren,
  authenticatedOrderStatusIndexRoute: authenticatedOrderStatusIndexRoute,
  globalOauth2CallbackHandlerRoute: globalOauth2CallbackHandlerRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_layout",
        "/(authenticated)/dashboard",
        "/(unathenticated)/auth",
        "/(authenticated)/order-status/",
        "/(global)/oauth2/callback/$handler"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_layout": {
      "filePath": "_layout.tsx"
    },
    "/(authenticated)/dashboard": {
      "filePath": "(authenticated)/dashboard",
      "children": [
        "/(authenticated)/dashboard/_layout",
        "/(authenticated)/dashboard/$/"
      ]
    },
    "/(authenticated)/dashboard/_layout": {
      "filePath": "(authenticated)/dashboard/_layout.tsx",
      "parent": "/(authenticated)/dashboard",
      "children": [
        "/(authenticated)/dashboard/_layout/commissions",
        "/(authenticated)/dashboard/_layout/downloads",
        "/(authenticated)/dashboard/_layout/home",
        "/(authenticated)/dashboard/_layout/order",
        "/(authenticated)/dashboard/_layout/sub-affiliates",
        "/(authenticated)/dashboard/_layout/wallet",
        "/(authenticated)/dashboard/_layout/admin",
        "/(authenticated)/dashboard/_layout/pay/$order-id",
        "/(authenticated)/dashboard/_layout/upgrade/$order-id",
        "/(authenticated)/dashboard/_layout/upgrade/",
        "/(authenticated)/dashboard/_layout/upgrade/pay/$order-id"
      ]
    },
    "/(unathenticated)/auth": {
      "filePath": "(unathenticated)/auth",
      "children": [
        "/(unathenticated)/auth/_layout",
        "/(unathenticated)/auth/$/"
      ]
    },
    "/(unathenticated)/auth/_layout": {
      "filePath": "(unathenticated)/auth/_layout.tsx",
      "parent": "/(unathenticated)/auth",
      "children": [
        "/(unathenticated)/auth/_layout/change-password",
        "/(unathenticated)/auth/_layout/forgotten-password",
        "/(unathenticated)/auth/_layout/invalid-link",
        "/(unathenticated)/auth/_layout/login",
        "/(unathenticated)/auth/_layout/network-registration",
        "/(unathenticated)/auth/_layout/registration"
      ]
    },
    "/(authenticated)/order-status/": {
      "filePath": "(authenticated)/order-status/index.tsx"
    },
    "/(authenticated)/dashboard/_layout/commissions": {
      "filePath": "(authenticated)/dashboard/_layout/commissions.tsx",
      "parent": "/(authenticated)/dashboard/_layout"
    },
    "/(authenticated)/dashboard/_layout/downloads": {
      "filePath": "(authenticated)/dashboard/_layout/downloads.tsx",
      "parent": "/(authenticated)/dashboard/_layout"
    },
    "/(authenticated)/dashboard/_layout/home": {
      "filePath": "(authenticated)/dashboard/_layout/home.tsx",
      "parent": "/(authenticated)/dashboard/_layout"
    },
    "/(authenticated)/dashboard/_layout/order": {
      "filePath": "(authenticated)/dashboard/_layout/order.tsx",
      "parent": "/(authenticated)/dashboard/_layout",
      "children": [
        "/(authenticated)/dashboard/_layout/order/$order-id"
      ]
    },
    "/(authenticated)/dashboard/_layout/sub-affiliates": {
      "filePath": "(authenticated)/dashboard/_layout/sub-affiliates.tsx",
      "parent": "/(authenticated)/dashboard/_layout"
    },
    "/(authenticated)/dashboard/_layout/wallet": {
      "filePath": "(authenticated)/dashboard/_layout/wallet.tsx",
      "parent": "/(authenticated)/dashboard/_layout"
    },
    "/(global)/oauth2/callback/$handler": {
      "filePath": "(global)/oauth2/callback.$handler.tsx"
    },
    "/(unathenticated)/auth/_layout/change-password": {
      "filePath": "(unathenticated)/auth/_layout/change-password.tsx",
      "parent": "/(unathenticated)/auth/_layout"
    },
    "/(unathenticated)/auth/_layout/forgotten-password": {
      "filePath": "(unathenticated)/auth/_layout/forgotten-password.tsx",
      "parent": "/(unathenticated)/auth/_layout"
    },
    "/(unathenticated)/auth/_layout/invalid-link": {
      "filePath": "(unathenticated)/auth/_layout/invalid-link.tsx",
      "parent": "/(unathenticated)/auth/_layout"
    },
    "/(unathenticated)/auth/_layout/login": {
      "filePath": "(unathenticated)/auth/_layout/login.tsx",
      "parent": "/(unathenticated)/auth/_layout"
    },
    "/(unathenticated)/auth/_layout/network-registration": {
      "filePath": "(unathenticated)/auth/_layout/network-registration.tsx",
      "parent": "/(unathenticated)/auth/_layout"
    },
    "/(unathenticated)/auth/_layout/registration": {
      "filePath": "(unathenticated)/auth/_layout/registration.tsx",
      "parent": "/(unathenticated)/auth/_layout"
    },
    "/(authenticated)/dashboard/$/": {
      "filePath": "(authenticated)/dashboard/$/index.tsx",
      "parent": "/(authenticated)/dashboard"
    },
    "/(unathenticated)/auth/$/": {
      "filePath": "(unathenticated)/auth/$/index.tsx",
      "parent": "/(unathenticated)/auth"
    },
    "/(authenticated)/dashboard/_layout/admin": {
      "filePath": "(authenticated)/dashboard/_layout/admin",
      "parent": "/(authenticated)/dashboard/_layout",
      "children": [
        "/(authenticated)/dashboard/_layout/admin/_layout"
      ]
    },
    "/(authenticated)/dashboard/_layout/admin/_layout": {
      "filePath": "(authenticated)/dashboard/_layout/admin/_layout.tsx",
      "parent": "/(authenticated)/dashboard/_layout/admin",
      "children": [
        "/(authenticated)/dashboard/_layout/admin/_layout/development",
        "/(authenticated)/dashboard/_layout/admin/_layout/",
        "/(authenticated)/dashboard/_layout/admin/_layout/promoter-detail/$user-id"
      ]
    },
    "/(authenticated)/dashboard/_layout/order/$order-id": {
      "filePath": "(authenticated)/dashboard/_layout/order.$order-id.tsx",
      "parent": "/(authenticated)/dashboard/_layout/order"
    },
    "/(authenticated)/dashboard/_layout/pay/$order-id": {
      "filePath": "(authenticated)/dashboard/_layout/pay.$order-id.tsx",
      "parent": "/(authenticated)/dashboard/_layout"
    },
    "/(authenticated)/dashboard/_layout/upgrade/$order-id": {
      "filePath": "(authenticated)/dashboard/_layout/upgrade/$order-id.tsx",
      "parent": "/(authenticated)/dashboard/_layout"
    },
    "/(authenticated)/dashboard/_layout/upgrade/": {
      "filePath": "(authenticated)/dashboard/_layout/upgrade/index.tsx",
      "parent": "/(authenticated)/dashboard/_layout"
    },
    "/(authenticated)/dashboard/_layout/admin/_layout/development": {
      "filePath": "(authenticated)/dashboard/_layout/admin/_layout/development.tsx",
      "parent": "/(authenticated)/dashboard/_layout/admin/_layout"
    },
    "/(authenticated)/dashboard/_layout/upgrade/pay/$order-id": {
      "filePath": "(authenticated)/dashboard/_layout/upgrade/pay.$order-id.tsx",
      "parent": "/(authenticated)/dashboard/_layout"
    },
    "/(authenticated)/dashboard/_layout/admin/_layout/": {
      "filePath": "(authenticated)/dashboard/_layout/admin/_layout/index.tsx",
      "parent": "/(authenticated)/dashboard/_layout/admin/_layout"
    },
    "/(authenticated)/dashboard/_layout/admin/_layout/promoter-detail/$user-id": {
      "filePath": "(authenticated)/dashboard/_layout/admin/_layout/promoter-detail.$user-id.tsx",
      "parent": "/(authenticated)/dashboard/_layout/admin/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
